import * as firebase from 'firebase/app'

import { auth, db } from '../config/firebase'

export const addEvent = async (campaignId, displayName, event) => {
  console.log('[addEvent] User', displayName, 'is adding event for campaignId', campaignId, ':', event)
  const data = {
    event,
    owner: auth.currentUser.uid,
    displayName,
    created: firebase.firestore.FieldValue.serverTimestamp()
  }

  const ref = await db.collection('campaigns').doc(campaignId).collection('events').add(data)

  console.log('[addEvent] Created event for campaignId', campaignId)

  return ref
}

export const updateEventDescription = async (campaignId, eventId, description) => {
  console.log('[updateEventDescription] Updating event description for campaignId', campaignId, ':', eventId)

  const eventRef = await db.collection('campaigns').doc(campaignId).collection('events').doc(eventId).set({
    description,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })

  console.log('[updateEventDescription] Updated event description for campaignId', campaignId, ':', eventId)

  return eventRef
}

export const deleteEvent = async (campaignId, eventId) => {
  console.log('[addEvent] Deleting event for campaignId', campaignId, ':', eventId)

  const ref = await db.collection('campaigns').doc(campaignId).collection('events').doc(eventId).delete()

  console.log('[deleteEvent] Deleted event for campaignId', campaignId, ':', eventId)

  return ref
}
